import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function BuyerAdminLogin() {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('https://didrouteapi.com/api/buyers/login', credentials);
      
      if (response.data.success) {
        localStorage.setItem('buyerToken', response.data.token);
        localStorage.setItem('buyerData', JSON.stringify(response.data.buyer));
        
        // Set up axios default authorization header
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
        
        navigate('/buyer/dashboard');
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-[-10px]">
      <div 
        className="flex items-center justify-center min-h-screen bg-cover bg-center relative"
        style={{
          backgroundImage: "url(https://images.pexels.com/photos/2150/sky-space-dark-galaxy.jpg?auto=compress&cs=tinysrgb&w=1600)",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 bg-white bg-opacity-5 backdrop-blur-md shadow-lg rounded-lg max-w-md w-full px-6 py-8 sm:px-10 sm:py-8">
          <div>
            <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-white">
              Buyer Sign In
            </h2>
          </div>

          {error && (
            <div className="mt-4 text-sm text-center text-red-500">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6 mt-8">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-300">
                Email address
              </label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={credentials.email}
                onChange={(e) => setCredentials({
                  ...credentials,
                  email: e.target.value
                })}
                className="mt-1 block w-full rounded-md bg-gray-800 bg-opacity-30 px-4 py-2 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-black"
                placeholder="Enter your email"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-300">
                Password
              </label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={credentials.password}
                onChange={(e) => setCredentials({
                  ...credentials,
                  password: e.target.value
                })}
                className="mt-1 block w-full rounded-md bg-gray-800 bg-opacity-30 px-4 py-2 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-black"
                placeholder="Enter your password"
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className={`w-full rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm transition-transform duration-200 ease-in-out transform hover:scale-105
                  ${loading 
                    ? 'bg-gray-500 cursor-not-allowed' 
                    : 'bg-indigo-500 hover:bg-indigo-400'}`}
              >
                {loading ? 'Processing...' : 'Sign in'}
              </button>
            </div>
          </form>

          <div className="text-sm text-center mt-4">
            <a href="/buyer/forgot-password" className="font-semibold text-indigo-400 hover:text-indigo-300">
              Forgot password?
            </a>
          </div>

          {/* <p className="mt-6 text-center text-sm text-gray-400">
            Not a member?{" "}
            <a href="/buyer/register" className="font-semibold text-indigo-400 hover:text-indigo-300">
              Register now
            </a>
          </p> */}
        </div>
      </div>
    </div>
  );
}
